/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const lpExternalLawyerStyle = {
  titleContainer: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      paddingTop: "4rem",
      paddingBottom: "9rem",
    },
  }),
  advantage: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingBlock: "1.5rem 2rem",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "3rem",
    },
  }),
  applicationSectionContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.primaryPale,
    paddingBlock: "3rem",
    [theme.breakpoints.up("md")]: {
      paddingBlock: "6rem 9rem",
    },
  }),
};
